<template>
  <div class="page-header-view" id="project-view">
    <!-- HEADER -->
      <vs-navbar
          v-model="activeTab"
          type="border"
          text-color="rgba(255,255,255,.6)"
          active-text-color="rgba(203,255,0,1)"
          class="text-white project-navbar p-2 mb-5 w-full" color="dark"
      >
        <div slot="title">
          <vs-navbar-title>
            <span>DETALLE DEL PROYECTO</span>
          </vs-navbar-title>
        </div>

        <vs-navbar-item :index="profileVerificationTabIndex" v-if="variant === 'risk-model'">
          <a class="text-sm">Resumen V. Proveedor</a>
        </vs-navbar-item>

        <vs-navbar-item :index="ARCTabIndex" v-if="variant === 'risk-model'">
          <a class="text-sm">ARC</a>
        </vs-navbar-item>

        <vs-navbar-item
            v-if="!isPersonMoral(project.client.user.person_type)"
            :index="scoreTabIndex" class="cursor-pointer">
          <a class="text-sm">Consulta Cdc</a>
        </vs-navbar-item>

        <vs-navbar-item :index="requestTabIndex" class="cursor-pointer">
          <a class="text-sm">Solicitud</a>
        </vs-navbar-item>

        <vs-navbar-item v-if="project.finance.crowdfunding_loan_type === 2" :index="riskFactorTabIndex" class="cursor-pointer">
          <a class="text-sm">Factores de riesgo</a>
        </vs-navbar-item>

         <vs-navbar-item :index="economicsTabIndex" class="cursor-pointer">
          <a class="text-sm">Económicos</a>
        </vs-navbar-item>

        <vs-navbar-item :index="prefundRevisionTabIndex" v-if="variant === 'project'">
          <a class="text-sm">Revisión </a>
        </vs-navbar-item>

        <vs-navbar-item :index="evidencesRevisionTabIndex" v-if="variant === 'project'">
          <a class="text-sm">Revisión Evidencias </a>
        </vs-navbar-item>

         <vs-navbar-item :index="publicationTabIndex">
          <a class="text-sm">Publicación</a>
        </vs-navbar-item>

        <vs-navbar-item :index="contractsTabIndex" class="cursor-pointer" v-if="variant === 'project'">
          <a class="text-sm">Contratos </a>
        </vs-navbar-item>

        <vs-navbar-item :index="contracts2TabIndex" class="cursor-pointer" v-if="variant === 'project'">
          <a class="text-sm">Contratos 2</a>
        </vs-navbar-item>

        <vs-navbar-item :index="pycTabIndex" v-if="variant === 'project'">
          <a class="text-sm">Pagos de proyecto</a>
        </vs-navbar-item>
      </vs-navbar>

    <div class="container tab-options">
      <profile-verification-resume
        v-if="activeTab === profileVerificationTabIndex && isMounted"
        :supplierId="project.supplier_id" />

      <arc-tab-v2
        v-if="activeTab === ARCTabIndex && isMounted"
        :personType="project.client.user.person_type"
        :personId="project.client.fiscal.id" />

      <score-tab
        :rfc="project.client.fiscal.rfc"
        v-if="(activeTab === scoreTabIndex && isMounted && !isPersonMoral(project.client.user.person_type))"></score-tab>

      <project-request-tab
        v-if="activeTab === requestTabIndex && isMounted"
        :id="id"
        ref="requestTab"
        :person_type="project.client.user.person_type" />

      <contracts-tab v-if="activeTab === contractsTabIndex" />

      <contracts2-tab v-if="activeTab === contracts2TabIndex" :project="project"/>

      <economics-tab
        ref="economicTab"
        v-if="activeTab === economicsTabIndex" />

      <project-prefund-revision-tab
        v-if="activeTab === prefundRevisionTabIndex"
        :id="id"
        :person_type="project.client.user.person_type" />

      <project-evidences-revision-tab
        v-if="activeTab === evidencesRevisionTabIndex"
        :id="id"
        :person_type="project.client.user.person_type" />

      <project-publication-tab
        v-if="activeTab === publicationTabIndex"
        :id="id"
        :person_type="project.client.user.person_type" />

      <risk-factor
        v-if="activeTab === riskFactorTabIndex"
        :projectId="id"></risk-factor>

      <div class="container" id="tab-pyc" role="tabpanel" aria-labelledby="pyc-tab" v-if="activeTab === pycTabIndex">
        <loan-payment-view />
      </div>
    </div>

    <vs-prompt
        title="Archivar el proyecto"
        @cancel="closeArchivePrompt"
        @accept="doArchiveProject"
        @close="closeArchivePrompt"
        accept-text="Confirmar"
        cancel-text="Cancelar"
        :is-valid="validArchivePrompt"
        :active.sync="showArchivePrompt">
        <div class="con-exemple-prompt">
          <span>Por favor indícanos el motivo por el cual se elimina el proyecto:</span>
          <br/><br/>
          <ul class="leftx">
            <li :key="index" :value="item.id" :text="item.label" v-for="(item,index) in resolutionCauseOptions">
              <vs-radio v-model="resolutionClientCause" vs-name="resolutionClientCause" :vs-value="item.id">{{item.label}}</vs-radio>
            </li>
          </ul>
          <vs-input v-if="resolutionClientCause == 4" placeholder="Describa" class="w-full" v-model="resolutionCause" />
        </div>
      </vs-prompt>

    <vs-popup
        title="Asignar vendedor al proyecto"
        :active.sync="showAssignAgentPrompt">
        <div class="con-exemple-prompt">

          <vx-select class="w-full mb-5"
            label="Lista de vendedores disponibles"
            v-model.lazy="agent_id"
            name="agent_id"
            :disabled="getAgentsList.length < 1"
            :placeholder="getAgentsList.length < 1 ? noDataPlaceholder : selectPlaceholder" >
            <vx-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in getAgentsList" class="w-full" />
          </vx-select>

          <vs-button :disabled="!agent_id" @click="saveAgent" color="primary" class="mr-5 mt-2">Asignar</vs-button>
          <vs-button @click="closeAgentPrompt" type="flat" color="primary">Cerrar</vs-button>
        </div>
      </vs-popup>

    <load-error v-if="failed" />

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import inputHelper from '@components/mixins/inputHelper';
import dateHelper from '@components/mixins/dateHelper';
import formHelper from '@components/mixins/formHelper';
import ProjectRequestTab from '@components/projectsv2/ProjectRequestTab.vue'
import ProjectPrefundRevisionTab from '@components/projectsv2/ProjectPrefundRevisionTab.vue'
import ProjectEvidencesRevisionTab from '@components/projectsv2/ProjectEvidencesRevisionTab.vue'
import ProjectPublicationTab from '@components/projectsv2/NewProjectPublicationTab.vue'
import EconomicsTab from '../projects/process-flow/tab-economy'
import ContractsTab from '../projects/process-flow/tab-contracts'
import Contracts2Tab from '../projects/process-flow/tab-contracts2'
import {User} from '@/models/User';
import ScoreTab from "@/views/admin/projects/process-flow/ScoreTab";
import ArcTabV2 from "@views/admin/projects/process-flow/ArcTabV2";
import LoanPaymentView from "@views/admin/loan-payment/loan-payment-view";
import RiskFactor from "@views/admin/risk-factors/RiskFactor";
import ProfileVerificationResume
  from "@views/admin/RiskModel/Dashboard/RiskModel/SupplierRiskModel/ProfileVerificationResume/ProfileVerificationResume.vue";

const headerFieldsDefinitions = [
  { id: 2, label: "ID del proyecto", field: "id", },
  { id: 4, label: "Estatus", field: "status_named" },
  { id: 3, label: "Alias", field: "alias", },
  { id: 1, label: "ID Externo", field: "external_id"},
]

const tabActionsDefs = [
  { index: 0, name: 'solicitud' },
  { index: 1, name: 'prefondeo' },
  { index: 2, name: 'postfondeo' },
]

const resolutionCauseDefinitions = [
  { id: 1, label: "El cliente optó por otro crédito" },
  { id: 2, label: "El cliente lo pagó de contado" },
  { id: 3, label: "El cliente optó por no realizar el proyecto" },
  { id: 4, label: "Otra razón" },
];

export default {
  mixins: [formHelper, inputHelper, dateHelper],
  props: {
    id: {
      type: Number|String|null,
    },
    variant: {
      type: String,
      default: 'project'
    }
  },
  data(){
    return {
      isMounted: null,
      onError: null,
      errorCode: null,

      mainSecR1: [],
      mainSecR2: [],

      isMaster: null,

      failed: null,
      activeTab: 0,

      project: {},
      indexDict: {
        scoreTabIndex: 0
      },
      currentAction: null,
      scoreTabIndex: 0,
      requestTabIndex: 2,
      economicsTabIndex: 3,
      prefundRevisionTabIndex: 4,
      evidencesRevisionTabIndex: 5,
      publicationTabIndex: 6,
      contractsTabIndex: 7,
      contracts2TabIndex: 8,
      pycTabIndex: 9,
      invoicesTabIndex: 10,
      riskFactorTabIndex: 12,
      profileVerificationTabIndex: 13,
      ARCTabIndex: 14,

      showArchivePrompt: false,
      resolutionCauseOptions: resolutionCauseDefinitions,
      resolutionClientCause: null,
      resolutionCause: "",

      showUnarchivePrompt: false,
      showAssignAgentPrompt: false,

      isArchived: false,
      agent_id: null,
      agent: null,
      selectPlaceholder: "Seleccione una opción",
      noDataPlaceholder: "No hay opciones disponibles",
      getAgentsList: [],
      allAgents: [],
    }
  },
  components: {
    ProfileVerificationResume,
    RiskFactor,
    LoanPaymentView,
    ArcTabV2,
    EconomicsTab,
    ContractsTab,
    Contracts2Tab,
    ProjectRequestTab,
    ProjectPrefundRevisionTab,
    ProjectEvidencesRevisionTab,
    ProjectPublicationTab,
    ScoreTab
  },
  computed: {
    ...mapState("auth", ["user"]),
    userId: function() {
      return this.user.user_id;
    },
    showFundingProgress(){
      return this.project.status >= 5 && this.project.status <= 8;
    },
    canArchiveProject() {
      return this.project.status < 5 && !this.isArchived;
    },
    canUnarchiveProject() {
      // Se pueden desarchivar solo los proyectos que archivo el proveedor
      return this.resolution_client_cause != 0 && this.isArchived;
    },
    validArchivePrompt(){
      if(this.resolutionClientCause == null){
        return false;
      }
      else {
        if(this.resolutionClientCause == 4){
          return this.resolutionCause.length > 0
        }
        else {
          return true;
        }
      }
    },
    hasAgent(){
      return this.agent != null && this.agent.length != 0;
    },
    agentName(){
      return this.hasAgent ? this.agent.name : "Sin asignar";
    },
    isBackoffice(){
      return this.$acl.check('isBackoffice');
    },
  },
  watch: {
    loading: function(newVal, oldVal) {
      if (newVal == true) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    }
  },
  async beforeMount() {
    this.loading = true;
    this.isMounted = false;
    await this.getProjectInfo();
    this.setNavFromParams();
    this.loading = false;
    this.isMounted = true;
  },
  methods: {
     ...mapActions('projects', [
          'approveProject',
          'preApproveProject',
      ]),
    isPersonMoral(person_type) {
      return User.isMoral(person_type);
    },
    showAmortTable() {
      this.$refs.economicTab.modalAmortizationTable()
    },
    async preapproveRequest(){
      this.activeTab = this.requestTabIndex;
      await (async() => {
        let ok = false;
        while(!ok) {
          if(this.$refs.requestTab != null){
            if(this.$refs.requestTab.checkIsMounted()){
              ok = true;
            }
          }
          await this.sleep(100);
        }
      })();
      let tab = this.$refs.requestTab;
      let res = await tab.requestPreapproval();
      if(res){
        this.$vs.dialog({
          type: 'confirm',
          color: 'warning',
          title: 'Preaprobar la solicitud',
          text: `¿Estás seguro que deseas preaprobar la solicitud?`,
          acceptText: "Preaprobar",
          cancelText: 'Cancelar',
          accept: this.doRequestPreapproval
        });
      }
    },

    async approveRequest(){
      this.activeTab = this.requestTabIndex;
      await (async() => {
        let ok = false;
        while(!ok) {
          if(this.$refs.requestTab != null){
            if(this.$refs.requestTab.checkIsMounted()){
              ok = true;
            }
          }
          await this.sleep(100);
        }
      })();

      let tab = this.$refs.requestTab;
      let res = await tab.requestApproval();

      if(res){
        this.$vs.dialog({
          type: 'confirm',
          color: 'warning',
          title: 'Aprobar la solicitud',
          text: `¿Estás seguro que deseas aprobar la solicitud?`,
          acceptText: "Aprobar",
          cancelText: 'Cancelar',
          accept: this.doRequestApproval
        });
      }
    },

    async doRequestPreapproval(){
      try {
        await this.preApproveProject(this.id);
        this.saveSuccessNotif();
      } catch (error) {
        this.warn(error);
        this.errorNotifDialog("Error", "Ha ocurrido un error desconocido");
      }
    },
    async doRequestApproval(){
      try {
        await this.approveProject(this.id);
        this.$vs.dialog({
          type: 'confirm',
          color: 'success',
          title: "Proyecto aprobado",
          text: "El proyecto ha sido aprobado correctamente",
          acceptText: "Aceptar",
          cancelText: 'Cerrar',
          accept: this.reloadPage,
          cancel: this.reloadPage,
        });
      } catch (error) {
        this.warn(error);
        if(error.response){
          this.errorNotifDialog("Error", error.response.data.error);
        }
        else {
          this.errorNotifDialog("Error", "Ha ocurrido un error en la aprobación");
        }
      }
    },
    async reloadPage(){
       window.location.reload();
    },
    axiosErrorException (err) {
      let errorJSON = err.response.data.errors;
      let errorStr = "";

      if(errorJSON) {
        Object.keys(errorJSON).forEach((item) => {
          errorStr += errorJSON[item][0] + "\n";
        })
      }

      return errorStr
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async assignAgentRequest(){
      this.agent_id = null;
      this.showLoading(true);
      this.getAgentsList = [];

      if(!this.isBackoffice){
        let res2 = await axios.get("/api/supplier/agents");
        let options = res2.data;
        this.allAgents = options;
        options.forEach(f => {
          this.getAgentsList.push({value: f.id, text: f.name});
        })
      }
      this.showLoading(false);
      this.showAssignAgentPrompt = true;
    },
    setNavFromParams(){
      let nav = this.$route.query.nav;
      if(nav && nav == "solicitud"){
        this.activeTab = 0;
      }
      else if(nav && nav == "postfondeo"){
        this.activeTab = 2;
      }
      else if(nav && nav == "prefondeo"){
        this.activeTab = 1;
      }
    },
    async getProjectInfo() {
      try {
        const requiredObjects = [
          "splits",
          "client.user",
          "client.user.personal",
          "client.user.business",
          "client.user.business.personal",
          "agent",
          "finance",
          "contracts",
          "supplier.user",
          "supplier.user.personal",
          "supplier.user.business",
          "supplier.user.business.personal",
          "agent"
        ];

        let params = "with[]=" + requiredObjects.join("&with[]=");
        let response = await axios.get(`/api/v2/projects/${this.id}?${params}`);
        //let response = await axios.get("/api/v1/supplier/projectInfo/" + this.id);
        this.onError = false;
        //this.project = response.data.project;
        this.project = response.data;
        this.isArchived = this.project.resolution == 1;
        this.isMaster = this.project.splits.length > 0;

        this.agent = this.project.agent;
      }
      catch (error) {
        this.processError(error.status);
      }
    },
    processError(code){
      this.onError = true;
      this.errorCode = code;
    },
    loadFields(){
      let mainSection = headerFieldsDefinitions;
      let total = mainSection.length;
      let r1 = Math.ceil(total / 2);
      let c = 1;
      mainSection.forEach(e => {
        if(c <= r1){
          this.mainSecR1.push(e);
        }
        else {
          this.mainSecR2.push(e);
        }
        c += 1;
      });
      this.loading = false;
      this.mounted = true;
    },
    fieldValue(field, format = null){
      let val = this.getNestedObject(this.project, this.arrayFromFieldName(field) );
      if(format != null && format != ''){
        return this.formatConvert(val, format);
      }
      else {
        return val || '-';
      }
    },
     formatConvert(val, format){
      if(format == "loaded"){
        return (val == null || val == '') ? "Pendiente" : "Cargado";
      }
      else if(format == "date"){
        return (val == null || val == '') ? "-" : this.regularDateFormat(val);
      }
    },
    arrayFromFieldName(fname){
      return fname.split('.');
    },
    getNestedObject(nestedObj, pathArr) {
      return pathArr.reduce((obj, key) =>
        (obj && obj[key] !== 'undefined') ? obj[key] : undefined, nestedObj);
    },
    archiveProjectRequest () {
      let mssg = "¿Realmente desea archivar el proyecto?";
      mssg += " Podrá consultarlo posteriormente en la lista de proyectos archivados."

      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Archivar proyecto',
        text: mssg,
        acceptText: "Archivar",
        cancelText: 'Cancelar',
        accept: this.archiveDialog
      });
    },
    archiveDialog(){
      //limpiar opciones
      this.resolutionClientCause = null;
      this.resolutionCause = "";
      this.showArchivePrompt = true;
    },
    async doArchiveProject(){
      this.loading = true;
      let obj = {why: this.resolutionClientCause, reason: this.resolutionCause, project: this.id };

      try {
        let res = await axios.post('/api/v1/supplier/archiveProject', obj);
        this.$vs.notify({
          color: 'success',
          title: 'Proyecto archivado',
          text: 'El proyecto ha sido archivado exitosamente'
        })

        await this.getProjectInfo();
      } catch (error) {
        this.$vs.notify({
         color: 'danger',
         title: 'Error',
         text: 'Ha ocurrido un error en la operación, intente más tarde'
       })
      }
      this.loading = false;
    },
    closeArchivePrompt() {
      this.showArchivePrompt = false
    },
    closeAgentPrompt() {
      this.showAssignAgentPrompt = false
    },
    async saveAgent(){
      if(this.agent_id == this.agent.id){
        this.closeAgentPrompt();
        return;
      }

      this.showLoading(true);
      try {
        let payload = {agent_id: this.agent_id, project_id: this.id};
        await axios.post('/api/v1/supplier/setSupplierAgentToProject', payload);
        this.agent = this.allAgents.find(f => f.id == this.agent_id);
        this.closeAgentPrompt();
        this.saveSuccessNotif();
      }
      catch (error) {
        this.warn(erro);
        this.failedOperationNotif();
      }
      this.showLoading(false);
    },
    shortDesc : function() {
      let desc = "";
      if(this.project.status != null){
        desc = "Tu proyecto ";
        switch(this.project.status){
          case 1:
            desc += "se encuentra en proceso de creación"
            break;
          case 2:
            desc += "se encuentra en revisión";
            break;
          case 3:
            desc += "está preaprobado";
            break;
          case 4:
            desc += "está aprobado";
            break;
          case 5:
            desc += "se encuentra en fondeo";
            break;
          case 6:
            desc += "está en firma de contratos";
            break;
          case 7:
            desc += "se encuentra en instalación";
            break;
          case 8:
            desc += "ha sido entregado";
            break;
          case 9:
            desc += "ha sido rechazado";
            break;
          case 10:
            desc += "fue reembolsado";
            break;
          default:
            desc += "está pendiente";
            break;
        }
        desc += ".";
      }
      return desc;
    },
    archiveReason(){
      const proj = this.project;
      if(proj.resolution_client_cause != 0 ){
        if(proj.resolution_client_cause == 4){
          return proj.resolution_cause;
        }
        else {
          let r = resolutionCauseDefinitions.find(el => el.id == proj.resolution_client_cause);
          if(r != null) return r.label;
          else return "-";
        }
      }
      else if(proj.resolution_supplier_cause != 0) {
        if(proj.resolution_supplier_cause == 2){
          return proj.resolution_cause;
        }
        else {
          let r = resolutionSupplierCauseDefinitions.find(el => el.id == proj.resolution_supplier_cause);
          if(r != null) return r.label;
          else return "-";
        }
      }
    },
    unarchiveProjectRequest () {
      let proj = this.project;
      let mssg = "¿Realmente desea desarchivar el proyecto " + proj.id + "?";

      if(proj.step != 4){
        mssg += " El proyecto se desarchivará con el estatus que tenía.";
      }
      else {
        // RNs
        // si tenia menos de 30 dias aprobado, se desarchiva como aprobado,
        // si tenia mas de 30 dias aprobado, se desarchiva como pre-aprobado
        if(proj.approved_days <= 30){
          mssg += " El proyecto se desarchivará en estatus aprobado.";
        }
        else {
          mssg += " El proyecto tenía más de 30 días de aprobado, por lo que se desarchivará pero volverá a estatus pre-aprobado.";
        }
      }

      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Desarchivar proyecto',
        text: mssg,
        acceptText: "Desarchivar",
        cancelText: 'Cancelar',
        accept: this.doUnarchiveProject
      });
    },
    doUnarchiveProject(){
      this.loading = true;
      let obj = { project: this.project.id };
      axios.post('/api/v1/supplier/unarchiveProject', obj)
      .then(response => {
        this.getProjectInfo();
        this.$vs.notify({
          color: 'success',
          title: 'Proyecto desarchivado',
          text: 'El proyecto ha sido desarchivado exitosamente'
        })
      })
      .catch(err => {
         this.$vs.notify({
          color: 'danger',
          title: 'Error',
          text: 'Ha ocurrido un error en la operación, intente más tarde'
        }),
        this.loading = false
      })
    },
    closeUnarchivePrompt() {
      this.showUnarchivePrompt = false
    },
  }
}
</script>
<style scoped>
  a:hover {
    color: #CBFF00  !important;
  }
</style>
